(function () {
  'use strict';

  var inflight = false;

  function getRoot(btn) {
    return btn.closest('[data-ldrop-product-swapper]');
  }

  function fetchHtml(url) {
    return fetch(url, { method: 'GET', credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTML fetch failed: ' + r.status);
        return r.text();
      });
  }

  function fetchProductData(handle, variantId) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      method: 'GET',
      credentials: 'same-origin'
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return {};
        var target = null;
        var inventory = {};
        (data.variants || []).forEach(function (v) {
          inventory[v.id] = v.inventory_quantity || 0;
          if (String(v.id) === String(variantId)) target = v;
        });
        return {
          inventory: inventory,
          variantAlt: (target && target.featured_image && target.featured_image.alt) || (target && target.title) || null,
          variantPrice: target ? target.price / 100 : null,
          productTitle: data.title || null,
          variantAvailable: target ? target.available : null,
          rawProduct: data
        };
      })
      .catch(function () { return {}; });
  }

  function swapGallery(parsed, root, variantAlt) {
    var fetched = parsed.querySelector('product-gallery');
    var ours    = root.querySelector('[data-role="gallery"] product-gallery');
    if (!fetched || !ours) return;
    fetched.querySelectorAll('.product-gallery__thumbnail-list-wrapper, .product-gallery__thumbnail-list')
      .forEach(function (n) { n.remove(); });
    if (variantAlt) {
      var slides = fetched.querySelectorAll('.product-gallery__media');
      var visible = 0;
      slides.forEach(function (s) {
        if ((s.getAttribute('data-alt') || '') === variantAlt) { s.removeAttribute('hidden'); visible++; }
        else s.setAttribute('hidden', '');
      });
      if (visible === 0 && slides.length) slides[0].removeAttribute('hidden');
    }
    ours.innerHTML = fetched.innerHTML;
    root.querySelectorAll('[data-role="gallery"] video').forEach(function (v) { v.removeAttribute('controls'); });
  }

  function swapTitle(parsed, root) {
    var t = parsed.querySelector('.product-info__title');
    var o = root.querySelector('[data-role="title"]');
    if (t && o) o.textContent = (t.textContent || '').trim();
  }

  function swapDescription(parsed, root) {
    var scope = parsed.querySelector('.product-info') || parsed;
    var t = scope.querySelector('.product-info__description, .rte');
    var o = root.querySelector('[data-role="description"]');
    if (t && o) o.innerHTML = t.innerHTML;
  }

  function swapPrice(parsed, root) {
    var scope = parsed.querySelector('.product-info') || parsed;
    var t = scope.querySelector('price-list, .price-list');
    var ow = root.querySelector('[data-role="price"]');
    if (!t || !ow) return;
    var op = ow.querySelector('price-list, .price-list');
    if (op) op.innerHTML = t.innerHTML;
  }

  function swapJudgeMe(parsed, root) {
    var t = parsed.querySelector('.jdgm-widget.jdgm-preview-badge');
    var o = root.querySelector('[data-role="rating"]');
    if (!t || !o) return;
    var fresh = t.cloneNode(true);
    fresh.setAttribute('data-role', 'rating');
    fresh.setAttribute('data-auto-install', 'false');
    Array.from(o.attributes).forEach(function (a) {
      if (a.name.startsWith('data-shopify')) fresh.setAttribute(a.name, a.value);
    });
    o.replaceWith(fresh);
  }

  function syncAtcForm(root, variantId, variantAvailable) {
    var input = root.querySelector('[data-ldrop-variant-input]');
    if (input) {
      input.value = variantId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    var btn   = root.querySelector('[data-role="atc-button"]');
    var label = root.querySelector('[data-role="atc-label"]');
    if (!btn) return;
    var avail = typeof variantAvailable === 'boolean' ? variantAvailable : true;
    avail ? btn.removeAttribute('disabled') : btn.setAttribute('disabled', '');
    if (label) {
      var t = avail ? btn.dataset.labelAvailable : btn.dataset.labelUnavailable;
      if (t) label.textContent = t;
    }
  }

  function syncThumbs(root, activeId) {
    var activeTitle = null;
    root.querySelectorAll('[data-variant-id]').forEach(function (t) {
      var active = t.dataset.variantId === activeId;
      t.classList.toggle('luggage-drop-product__thumbnail--active', active);
      t.setAttribute('aria-current', active ? 'true' : 'false');
      if (active && t.dataset.productTitle) activeTitle = t.dataset.productTitle;
    });
    if (activeTitle) {
      var labelValue = root.querySelector('.luggage-drop-product__thumbnails-label-value');
      if (labelValue) labelValue.textContent = activeTitle;
    }
  }

  function reinitJudgeMe(root) {
    var badge = root.querySelector('[data-role="rating"]');
    if (!badge) return;
    try {
      if (typeof window.jdgm?.customWidgetLoader?.loadWidgets === 'function') { window.jdgm.customWidgetLoader.loadWidgets(); return; }
      if (typeof window.jdgm?.customWidget?.initiate === 'function') { window.jdgm.customWidget.initiate(badge); return; }
      if (typeof window.jdgm?.initialize === 'function') window.jdgm.initialize();
    } catch (e) { console.warn('[ldrop-swapper] Judge.me reinit failed', e); }
  }

  function reinitInfiniteOptions(product) {
    var c = document.getElementById('infiniteoptions-container');
    if (!c) return;
    if (product) window.shoppadProductJSON = product;
    var fresh = document.createElement(c.tagName);
    Array.from(c.attributes).forEach(function (a) { fresh.setAttribute(a.name, a.value); });
    c.replaceWith(fresh);
    var api = window.Shoppad?.apps?.infiniteoptions;
    if (typeof api?.init === 'function') { try { api.init(); } catch (e) {} }
  }

  function reinitTabby(root) {
    var el = root.querySelector('[data-ldrop-tabby]');
    if (!el) return;
    var fresh = document.createElement(el.tagName);
    Array.from(el.attributes).forEach(function (a) { fresh.setAttribute(a.name, a.value); });
    el.replaceWith(fresh);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-variant-id][data-product-handle]');
    if (!btn) return;

    var swapperRoot = getRoot(btn);
    if (!swapperRoot) return;

    var productRoot      = swapperRoot.querySelector('.luggage-drop-product');
    var currentVariantId = productRoot && productRoot.dataset.featuredVariantId;
    var targetVariantId  = btn.dataset.variantId;
    var targetHandle     = btn.dataset.productHandle;

    if (targetVariantId === currentVariantId || inflight) return;
    e.preventDefault();

    inflight = true;
    document.documentElement.setAttribute('data-ldrop-loading', 'true');

    var productUrl = '/products/' + encodeURIComponent(targetHandle) + '?variant=' + encodeURIComponent(targetVariantId);

    Promise.all([fetchHtml(productUrl), fetchProductData(targetHandle, targetVariantId)])
      .then(function (results) {
        var html = results[0];
        var data = results[1];
        var parsed = new DOMParser().parseFromString(html, 'text/html');

        swapGallery(parsed, productRoot, data.variantAlt);
        swapTitle(parsed, productRoot);
        swapDescription(parsed, productRoot);
        swapPrice(parsed, productRoot);
        swapJudgeMe(parsed, productRoot);
        syncAtcForm(productRoot, targetVariantId, data.variantAvailable);
        syncThumbs(productRoot, targetVariantId);

        productRoot.dataset.featuredVariantId = targetVariantId;

        reinitJudgeMe(productRoot);
        reinitInfiniteOptions(data.rawProduct);
        reinitTabby(productRoot);

        document.dispatchEvent(new CustomEvent('ldrop:variant-change', {
          detail: { variantId: targetVariantId, productHandle: targetHandle, inventory: data.inventory }
        }));
      })
      .catch(function (err) { console.warn('[ldrop-swapper] swap failed', err); })
      .finally(function () {
        inflight = false;
        document.documentElement.removeAttribute('data-ldrop-loading');
      });
  });
})();
